module.exports = __webpack_public_path__ + "static/media/tutor-Bimg.75928bba.jpg";